import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { profile } from 'routes/route.map'
import { MobileProfileHeader } from '../mobileProfileHeader'
import { MobileBalanceSection } from '../mobileBalanceSection'
import { MobileInfoContent } from '../mobileInfoContent'
import { BottomNavigation } from '../../../../public/events/overview/components/bottomNavigation'

import * as styles from './styles'

const MobileProfileLayoutComponent = ({
	entity,
	onUpdateProfile,
	onChangePassword,
	isLoading,
	children,
}) => {
	const [activeTab, setActiveTab] = useState('account')
	const [walletLoading, setWalletLoading] = useState(true)
	const history = useHistory()

	// Track entity changes and wallet loading state
	useEffect(() => {
		// Consider wallet loaded when we have entity with wallet and balance > 0 OR after a delay
		if (entity?.wallet && typeof entity.wallet.balance === 'number') {
			if (entity.wallet.balance > 0) {
				// If we have a positive balance, wallet is definitely loaded
				setWalletLoading(false)
			} else {
				// If balance is 0, wait a bit to see if it updates
				const timer = setTimeout(() => {
					setWalletLoading(false)
				}, 1000) // Wait 1 second for potential wallet update

				return () => clearTimeout(timer)
			}
		} else {
			setWalletLoading(true)
		}
	}, [entity])

	const handleTabChange = (tabId) => {
		setActiveTab(tabId)
	}

	const handleTopUpClick = () => {
		history.push(profile.balance())
	}

	return (
		<>
			<MobileProfileHeader
				title="Profile"
				activeTab={activeTab}
				onTabChange={handleTabChange}
			/>

			<div css={styles.contentContainer}>
				<div css={styles.content}>
					{/* Account Tab Content */}
					{activeTab === 'account' && (
						<div css={styles.tabContent}>
							<MobileBalanceSection
								currentBalance={entity?.wallet?.balance}
								currency="$"
								onTopUpClick={handleTopUpClick}
								isLoading={isLoading || !entity || walletLoading}
							/>
							{children}
						</div>
					)}

					{/* Info Tab Content */}
					{activeTab === 'info' && (
						<div css={styles.tabContent}>
							<MobileInfoContent />
						</div>
					)}
				</div>
			</div>

			<BottomNavigation />
		</>
	)
}

MobileProfileLayoutComponent.propTypes = {
	entity: PropTypes.shape(),
	onUpdateProfile: PropTypes.func,
	onChangePassword: PropTypes.func,
	isLoading: PropTypes.bool,
	children: PropTypes.node,
}

export default MobileProfileLayoutComponent 